import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { useDropzone } from 'react-dropzone';
import { RadioButton } from "primereact/radiobutton";
import ReactQuill from "react-quill";

// Icons
import BlackGallery from '../../../assets/icons/black-gallery.svg';
import Gallery from '../../../assets/icons/gallery.svg';
import Video from '../../../assets/icons/video.svg';
import BlackVideo from '../../../assets/icons/black-video.svg';
import Upload from '../../../assets/icons/upload.svg';
import Trash from '../../../assets/icons/trash.svg';
import Img from '../../../assets/images/image.jfif';
import Loader from '../../loader/loader'

import useToastNotification from '../../../hooks/useToastNotification';
import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, SearchAboutUs, DeleteAboutUs, CreateAboutUs, UpdateAboutUs, GetAboutUs, baseUrl } from '../../../utils/api';

function Banner() {
    const { showError, showSuccess } = useToastNotification();
    const [text, setText] = useState("");
    const [data, setData] = useState([]); // List of items
    const [visibleImageUpload, setVisibleImageUpload] = useState(false);
    const [visibleVideoUpload, setVisibleVideoUpload] = useState(false);
    const [videoName, setVideoName] = useState('');
    const [imageName, setImageName] = useState('');
    const [uploadedFile, setUploadedFile] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [videoPreview, setVideoPreview] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [defaultImg, setDefaultImg] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const quillFormats = [
        'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike',
        'blockquote', 'code-block', 'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', 'color', 'background', 'direction'
    ];
    
    const quillModules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],  // Headers & Fonts
            [{ 'size': ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px', '40px', '44px', '48px', '54px', '60px', '72px', '80px'] }],  // Custom font sizes
            ['bold', 'italic', 'underline', 'strike'],  // Formatting options
            ['blockquote', 'code-block'],  // Blockquote and code block
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Lists
            [{ 'indent': '-1' }, { 'indent': '+1' }],  // Indentation
            [{ 'direction': 'rtl' }],  // Text direction (RTL)
            [{ 'align': [] }],  // Text alignment
            [{ 'color': [] }, { 'background': [] }],  // Text and background colors
            ['link', 'image', 'video'],  // Inserting links, images, and videos
            [{ 'script': 'sub' }, { 'script': 'super' }],  // Subscript/Superscript
            ['clean']  // Remove formatting
        ]
    };
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            // محدود کردن تعداد فایل‌ها به 2
            const remainingCount = 2 - uploadedFile.length;
            const newFiles = acceptedFiles.slice(0, remainingCount); // فایل‌های جدید تا حد مجاز

            // اضافه کردن فایل‌ها به آرایه
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // تولید preview برای فایل‌های جدید
            const newFilesWithPreview = newFiles.map((file) => ({
                file,
                preview: URL.createObjectURL(file),
            }));

            // افزودن preview به آرایه
            setUploadedFiles((prev) => [...prev, ...newFilesWithPreview]);

            // بستن پنجره آپلود
            setVisibleImageUpload(false);
        },
        accept: 'image/*',
        maxFiles: 2,
    });


    const convertToBase64 = async (file) => {
        return await toBase64(file).then(result =>
            result.substr(result.indexOf(",") + 1)
        );
    };

    const handleFileUploadAdd = async (file, id, isDefault) => {
        const formData = {
            filsBase64: await convertToBase64(file),
            sourceId: id,
            isDefault: isDefault,
        };

        try {
            setUploadStatus('در حال آپلود فایل...');
            await AttachFileCreate(formData); // مطمئن شوید این متد API به درستی تنظیم شده
            setUploadStatus('آپلود فایل با موفقیت انجام شد');
        } catch (error) {
            setUploadStatus('عملیات آپلود با خطا مواجه شد');
            console.error('Upload error:', error);
        }
    };

    const onAddItemSubmitted = async (id) => {
        // add images if exist 
        uploadedFile.map(async (item, index) => {
            const image = item;
            await handleFileUploadAdd(image, id, index === defaultImg);
        }
        )


        // add new item to the top of the list
        await GetAboutUs({ id }).then(response => {
            setData(old => [response.data.data, ...old]);
        }).catch(error => showError(error.response.data));
    }


    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await SearchAboutUs({
                description: "",
                pageSize: 0,
                pageIndex: 0
            });
            const items = response.data.data.items || [];
            setData(items);
            if (items.length > 0) {
                setText(items[0].description);
                const images = items[0].images.map((img) => ({
                    preview: baseUrl + 'io/112x112/' + img.url,
                    file: null,
                    imageId: img.id,
                    id: items[0].id
                }));
                setUploadedFiles(images);
            }
        } catch (error) {
            showError("خطا در دریافت اطلاعات لیست");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!text.trim()) {
            return showError("وارد کردن متن الزامی است");
        }
        setLoading(true);
        try {


            // چک کردن اینکه آیا داده‌ای موجود است
            if (data.length == 1) {
                let pay = {
                    id: data[0].id,
                    description: text,
                };
                // اگر داده‌ها وجود دارند، آپدیت انجام می‌شود
                await UpdateAboutUs(pay);
                // بررسی و جایگزینی تصاویر
                if (uploadedFile.length > 0) {
                    // حذف تصاویر قبلی
                    if (data[0]?.images > 2) {
                        const previousImages = data[0]?.images || [];
                        for (const img of previousImages) {
                            await AttachFileDelete({
                                id: img.id
                            }); // حذف تصویر قدیمی
                        }
                    }


                    // آپلود تصاویر جدید
                    for (let i = 0; i < uploadedFile.length; i++) {
                        const file = uploadedFile[i];
                        const isDefault = i === defaultImg;
                        await handleFileUploadAdd(file, data[0].id, isDefault); // آپلود تصویر جدید
                    }
                }
                showSuccess("اطلاعات با موفقیت به‌روزرسانی شد");
                fetchData()
            } else {
                let pay = {
                    description: text,
                };
                // اگر داده‌ها موجود نباشند، ایجاد داده جدید انجام می‌شود
                let res = await CreateAboutUs(pay);
                const id = res.data.data; // created item id
                await onAddItemSubmitted(id);  // آپلود فایل‌ها یا عملیات دیگر
                showSuccess("عملیات با موفقیت انجام شد");
            }

        } catch (error) {
            showError(error.response?.data?.message || "خطایی رخ داد");
        } finally {
            setLoading(false);
        }
    };


    const handleDelete = async (id) => {
        try {
            await DeleteAboutUs(id);
            showSuccess("با موفقیت حذف شد");
            // fetchData();
        } catch (error) {
            showError("خطا در حذف آیتم");
        }
    };

    const handleRemoveFile = () => {
        setUploadedFile(null);
        setImagePreview(null);
        setVideoPreview(null);
    };

    const handleDeleteImage = async (item, image) => {
        try {
            await UpdateAboutUs({
                id: item.id,
                description: item.description,
                images: data.find(i => i.id === item.id).images.filter(img => img !== image),
            });
            showSuccess("تصویر با موفقیت حذف شد");
            // fetchData();
        } catch (error) {
            showError("خطا در حذف تصویر");
        }
    };

    const handleRemoveImage = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setImagePreview(prevPreviews => {
            const newPreviews = [...prevPreviews];
            newPreviews.splice(index, 1); // Remove the preview at the same index
            return newPreviews;
        });
    };
    const handleRemoveImage1 = async(index ,imageId) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
            await AttachFileDelete({
                id: imageId,
                // id: id
            });
            fetchData()
        

    };
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
    return (
        <>
            <div>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                    {uploadedFiles.map((image, index) => (
                        <div key={index}>
                            <div className="upload-file-btn">
                                <img src={image.preview} alt="Uploaded preview" className="image-preview" />
                                <div className="upload-file-btn-bottom">

                                    <div>
                                        <img src={Trash} alt="" onClick={() => handleRemoveImage1(index, image.imageId)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {uploadedFiles.length < 2 && (
                        <div >

                            <div className='upload-file-btn' onClick={() => setVisibleImageUpload(true)}>
                                <img src={Gallery} alt="" />
                                <h6 className='fw-500 text-[#669D24] text-sm'>انتشار تصویر</h6>
                            </div>

                        </div>
                    )}
                </div>
            </div>

            <Form className='mt-3' onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>متن مورد نظر را وارد کنید.</Form.Label>
                    <ReactQuill
                                theme="snow"
                                value={text}
                                onChange={setText}
                                modules={quillModules}
                                formats={quillFormats}
                                style={{ minHeight: '200px' }}
                            />
                    {/* <Form.Control as="textarea" rows={3} style={{ minHeight: '100px' }} placeholder='متن ...' value={text} onChange={(e) => setText(e.target.value)} /> */}
                </Form.Group>
                <div className='w-100 d-flex justify-content-end'>
                    <button type='submit' disabled={loading} className='btn btn-primary'>{loading === true ? "در حال ثبت" : 'ثبت'}</button>
                </div>
            </Form>
            {/* <hr />
            <div className='list-defult'>
                <h6 className='fw-500 d-flex align-items-center gap-2'><img src={BlackGallery} alt="" /> تصاویر</h6>

                <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                    {data.map(item => (
                        <div key={item.id} className="item-container">
                            <div className='d-flex align-items-center gap-2' style={{ flexWrap: 'wrap' }}>
                                {item.images?.map((image, index) => (
                                    <div className='upload-file-btn' key={`${item.id}-${index}`}>
                                        <img
                                            src={baseUrl + image.url || Img}
                                            alt="Uploaded preview"
                                            className="image-preview"
                                        />
                                        <div className='upload-file-btn-bottom'>
                                            <div className='d-flex align-items-center'>
                                                <RadioButton
                                                    inputId={`default-${item.id}-${index}`}
                                                    name={`defaultImg-${item.id}`}
                                                    value={image}
                                                    onChange={() => setDefaultImg({ itemId: item.id, image })}
                                                    checked={defaultImg?.itemId === item.id && defaultImg.image === image}
                                                />
                                                <label
                                                    htmlFor={`default-${item.id}-${index}`}
                                                    className="ml-2">
                                                    پیش فرض
                                                </label>
                                            </div>
                                            <div
                                                onClick={() => handleDeleteImage(item, image)}
                                                style={{ cursor: 'pointer' }}>
                                                <img src={Trash} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
            {/* upload image  */}
            <Dialog header="انتشار تصویر" visible={visibleImageUpload} maximizable style={{ width: '40vw' }} onHide={() => setVisibleImageUpload(false)}>
                <div className='d-flex gap-2 align-items-center' style={{ flexWrap: 'wrap' }}>
                    {
                        imagePreview.length > 0 ?
                            <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                {imagePreview.map((image, index) => (
                                    <div className='list-defult'>

                                        <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                            <div className='upload-file-btn'>
                                                <img src={image} alt="Uploaded preview" className="image-preview" />
                                                <div className='upload-file-btn-bottom'>
                                                    <div className='d-flex align-items-center' >
                                                        <RadioButton inputId={image} name="selected-images" value={index} onChange={(e) => setDefaultImg(e.value)} checked={defaultImg === index} />
                                                        <label htmlFor="ingredient1" className="ml-2">پیش فرض</label>

                                                    </div>
                                                    <div>
                                                        <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                ))}
                            </div> :
                            <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                                <input {...getInputProps()} />
                                <div>
                                    <img src={Upload} alt="" className='mx-auto' />

                                    <p className='text-xs mt-2 font-medium'>تصویر مورد نظر را از این قسمت وارد کنید.</p>
                                    <h6 className='text-[10px]'>بهترین ابعاد: 290 * 290</h6>
                                    <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                                </div>

                            </div>

                    }


                </div>
            </Dialog>
            {/* upload video  */}
            <Dialog header="انتشار ویدیو" visible={visibleVideoUpload} maximizable style={{ width: '40vw' }} onHide={() => setVisibleVideoUpload(false)}>
                <div className='dialog-body mx-4'>
                    <div {...getRootProps()} className="upload-box mt-4">
                        <input {...getInputProps()} />
                        {
                            videoPreview ? (
                                <video controls className="video-preview">
                                    <source src={videoPreview} type="video/mp4" />
                                    مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                                </video>
                            ) : (
                                <div>
                                    <img src={Upload} alt="" className='mx-auto' />
                                    <p className='text-xs mt-2 font-medium'>ویدیو مورد نظر را از این قسمت وارد کنید</p>
                                </div>
                            )
                        }
                    </div>

                    {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                    <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>

                </div>
            </Dialog>
        </>
    );
}
export default Banner;
